export const appStrings_enUS = {
	"sign_in_by_phone_message": "Hi! nice to see you :)",
	"enter_code_message": "We sent a verification code to- ",
	"sign_in_by_email_message": "Hi, please sign in with email and password",
	'verification_code_message': '{{pincode}} is your verification code.',
	'resend': 'Send again',
	'error_general': 'General error. Please try again.',
	'error_invalid_phone_verification_code': 'It seems the code you have entered is invalid. Please try again.',
	'error_invalid_sign_in_email_already_exists': 'This email exists. Please enter a different email.',
	"sign_up_message": "We are almost done",
	"sign_update_message": "We are almost done",
	'confirmation_password_reset': 'Instructions were sent to your mail account.',
	'error_reset_password_missing_email': 'Please enter your email for password renewing.',
	'invalid_email_entered': 'The email you have entered is invalid',
	'error_reset_password': 'It seems the email you have entered is invalid. Please try again.',
	"anonymous_orderer": "Anonymous",
	"cell": "Phone number",
	'order': 'Order',
	'pay': 'Pay',
	'default': 'Default',
	'save': 'Save',
	'okay': 'OK',
	'close': 'Close',
	'back': 'Back',
	'continue': 'Continue',
	'checkout': 'Checkout',
	'register': 'Register',
	'remove': 'Remove',
	'reorder_action': 'Re-order NOW!',
	'more': 'more',
	'load_more_orders': 'Load more orders',
	'loading_order_details': 'loading order details...',
	'delivery': 'Delivery',
	'take_away': 'Take Away',
	'takeaway': 'Take Away',
	'otcSeated': 'Seated',
	'seated': 'Seated',
	'_and': 'and',
	'verification_code': 'Verification code',
	'error_title': 'Hmm...',
	'error_invalid_sign_in_credentials': 'It seems your email or password is wrong. Please try again.',
	'confirmation_title': 'Yey!',
	'main': 'Main',
	'logout': 'Logout',
	'name': 'Name',
	'phone': 'Phone',
	'invalid_phone': 'Invalid phone',
	'email': 'Email',
	'password': 'Password',
	'reset_password': 'Reset Password',
	'forgot_your_password': 'Forgot Password',
	"auth_enable_anonymous": "<span class='text-lighter text-xs'>Trouble receiving SMS?&nbsp;</span><div>Continue as a guest</div>",
	'auth_q': 'Want to save time?',
	'auth_q_cont': 'Register / Sign in',
	'preparing-food': 'There are no items in the order yet...',
	'sign_in_nav': 'Register / Sign in',
	'sign_in_action': 'Continue',
	'sign_in_title': 'Sign in',
	'sign_up_action': 'Register',
	'sign_up_q': 'Your first time?',
	'sign_up_q_cont': 'Register',
	'sign_up_prompt_title': 'Wierd you still haven\'t registered, with-',
	'sign_up_prompt_content': 'Sign up prompt content',
	'sign_up_prompt_ok': 'Sign me up',
	'sign_up_prompt_cancel': 'Continue as guest',
	'search': 'Search',
	'sold_out': 'Sold out',
	'my_account': 'My Account',
	'my_account_description': 'You can edit your personal details here.',
	'personal_information': 'Personal Information',
	'first_name': 'First Name',
	'card_holder_name': 'Who\'s paying',
	'received_payments': 'Payments Received',
	'last_name': 'Last Name',
	'mobile': 'Mobile',
	'my_wallet': 'My Wallet',
	'my_wallet_info': 'My Wallet Setup',
	'my_wallet_description': 'You can add a payment method, or change the default payment method.',
	'add_to_wallet': 'Add to wallet',
	'credit_card_number': 'Credit Card Number',
	'credit_type': 'Credit Type',
	'cvv': 'CVV',
	'comments': 'Comments',
	'my_history': 'Transaction History',
	'my_history_info': 'Open order and history',
	'my_history_description': 'Your history of visits and orders can be found below.',
	'by_site': 'By site',
	'by_date': 'By date',
	'add_pm': 'Add payment method',
	'business_or_user_id': 'Id card or business id',
	"please_confirm": "Please approve",
	"please_enter_value": "Please enter value",
	"are_you_sure": "Are you sure?",
	"Cancel": "Cancel",
	"update_account": "Update account",
	"view_bill": "View receipt",
	"send_invoice_prompt": "Want the invoice by Email or SMS?",
	"send_invoice_success": "The invoice was sent successfully",
	"send_invoice_email": "Email",
	"send_invoice_sms": "SMS",
	"goto-rest-page": "Go to restaurant page",
	"reload_app": "Reload page",
	"reload_app_info": "Test environment. version: ",
	"enter_order_no": "Enter order code",
	"order_short_code": "Order code",
	"open_in_app": "Open in app",
	"OR": "Or",
	"AMOUNT_TO_PAY": "Amount to pay",
	"TIP_TO_PAY": "Tip to pay",
	"TABLE_BILL": "Table bill",
	"WAITER": "Waiter",
	"PAY_WITH": "Pay with",
	"PAY_WITH_WALLET": "Pay with wallet",
	"SELECT_ALTERNATE_PYMENT": "Select alternate payment",
	"PAY": "Pay",
	"clear": "Clear",
	"please_enter_signature": "Please enter signature",
	"notes": "Notes",
	"next": "Next",
	"day": "Day",
	"download_invoice": "Download receipt",
	"view_invoice": "View invoice",
	"partial_payment": "Partial payment",
	"split_payment_by": "Split payment by",
	"other": "Other",
	"gratuity": "Tip",
	"add_gratuity": "Add Tip",
	"current_gratuity": "Current tip",
	"current_payment": "Payment amount",
	"order_balance": "Order balance",
	"without_gratuity": "No tip",
	"GRATUITY_AMOUNT": "Tip amount",
	"amount": "Amount",
	"GRATUITY_PERCENT": "Tip percent",
	"percent": "percent",
	"ENTER_CVV": "Enter CVV",
	"SAVE_ACCOUNT_PAYMENT_INFO": "Save your card in our digital wallet for quicker payments on upcoming orders",
	"expiration": "Expiration",
	"PASS_ORDER": "Sharing bill?",
	"PASS_ORDER_TITLE": "Pass to friend",
	"MAKE_ADDITIONAL_PAYMENT_ONDEVICE": "Make additional payment",
	"PASS_ORDER_BY_PHONE_MESSAGE": "To pass order by cell, please enter cell number",
	"PASS_ORDER_BY_PHONE_CAPTION": "Cell number",
	"PASS_ORDER_BY_PHONE_SEND": "Send order",
	"PASS_ORDER_BY_PHONE_QR_MESSAGE": "or scan QR",
	"PASS_ORDER_SENT_SUCCESS": "Order sent successfully",
	"CANNOT_SEND_ORDER_BY_SMS": "Cannot send order by SMS.",
	"READ_AND_APPROVE_CONTRACT": "I've read & approved",
	"READ_AND_APPROVE_CONTRACT_C": "Terms of Service",
	"READ_AND_APPROVE_CONTRACT_D": "Privacy Notice",
	"CONTRACT_C": "Terms of Service",
	"CONTRACT_D": "Privacy Notice",
	"WELCOME_BACK": "Welcome back, {{name}}",
	"CONTINUE_WITHOUT_GRATUITY": "Continue without tip",
	"WITHOUT_GRATUITY": "Without tip",
	"PERFORMING_PAYMENT": "Performing payment...",
	'full-payment': 'Pay in Full',
	'partial-payment': "Split Payment",
	'pay-with-saved': "Pay with saved card",
	"ID_CARD": "Card holder's Id",
	"ENTER_IDCARD": "Enter id card",
	"ENTER_IDCARD_MESSAGE": "Enter Id for card: {{card}}",
	"ENTER_INVOICE_EMAIL": "Enter email address",
	"GOT_IT": "Got it",

	"split_amount_topay": "Choose a check for payment",
	"split_check_name": "Check {{v}}",
	"table": "Table",
	"nutritional_info": "Nutritional Info",
	"service_charges_applied": "{{name}} already applied",
	"app_smart_banner_title": "Browser mode?",
	"app_smart_banner_body": "The app is better :)",
	"waiter_payment": "General payment",
	"additional_details": "Additional Details",
	"yes": "Yes",
	"no": "No",
	"diner": "Diner",
	"address": "Address",
	"zip": "Zip Code",
	"state": "State",
	"city": "City",
	"billing_address": "Billing address",
	"add-item": "Add",
	"add-items": "Add items",
	"goto-payment": "Select How to Pay",
	"goto-tip": "Add Tip",
	"EX_PAYMENT_MODAL": "Make Payment",
	"select_items": "Select Items",
	"pay_by_items": "Pay by Item",
	"pay_by_diners": "Pay by Diner",
	"pay_by_items_title": "I'm paying for...",
	"pay_by_items_discount": "Order discount of {{val}}: is divided proportionally between the items.",
	"partial_payment_title": "How much do you want to pay?",
	"partial_payment_calcs_title": "Additional calculation options",
	"paying_for": "Paying for",
	"out_of": "Out of",
	"at_the_table": "At the table",
	"back_to_bill": "Back to the Check",
	"server_knows": "The server knows that you paid",
	"want_to_add_tip": "Want to add a tip?",
	"want_to_add_more_tip": "Add additional tip?",
	"order_payed_in_full": "Your order has been paid in full",
	"whoIsPaying": "Who's paying?",
	"surcharge_will_be_added_to_tip": "Excess balance will be added to the tip",
	"EX_PAYMENT": {
		"dialog_title": "Payment Verification",
		"wallet_title": "Card Verification",
		"wallet-popup-title": "Card saved successfully",
		"description": "This page is used to verify the payment method used on the site. Actual payment will occur on the business' site once the verification process is complete. Please verify that all of the details on this page are correct and fill out the required credit card details.",
		"popup-title": "Payment Verification Complete",
		"form-title": "Credit Card Details",
		"popup-description": "Complete the transaction on the business' site",
		"submit-btn": "Continue",
		"clear": "Clear",
		"credit_card_number": "Credit Card Number",
		"expiration": "Expiration",
		"cancel": "Cancel",
		"currency": "Currency:",
		"transaction_details": "Transaction Details",
		"total_amount": "Total Amount",
		"month": "Month",
		"year": "Year",
		"click_here": "Click here",
		"save":"Save",
		"error_client_credentials": "An error occurred. Please try again.",
		"error_wallet_credentials": "This payment method isn't working right now. Please choose another payment method or try again in a few minutes.",
		"wallet_add_pending": "Hang tight! We're saving your card and it may take a few minutes to appear in your wallet",
		"Q_SAVEPM_1": "Interested in a faster order process?",
		"Q_SAVEPM_2": "You can save your payment method in Tabit's digital wallet for quicker and faster payments",
		"Q_SAVEPM_3": "Pay and Save",
		"Q_SAVEPM_4": "Pay without saving",
	},
	"_LOYALTY": {
		"sign_title": "Sign in / Register",
		"sign_description": "Save your card details in our digital wallet for easier and quicker payment",
		"sign_other": "Please enter your phone and click continue",
		"register_title": "Register",
		"confirm_title": "Almost done…",
		"banner_title_start": "Sign up for ",
		"banner_title_end": "digital wallet for quick payment",
		"banner_save_time": "Hi, want to save time?",
		"banner_side_start": "Save credit card details in",
		"banner_side_end": "Wallet to pay quickly",
		"banner_side_ligin_start": "You are connected to",
		"hi_name": "Hi {{name}}",
		"welcome": "Welcome!",
		"sprompt_desc": "Review, split and pay the check yourself",
		"sprompt_ok": "Connect with <ilogow></ilogow><br> for quick payment",
		"sprompt_cancel": "Continue as a guest",
		"sprompt_license": "By using Tabit Pay, you agree to our ",
		"sprompt_desc_additems": "You will need to login to continue",
		"sprompt_ok_additems": "Connect with <ilogow></ilogow>",
		"sprompt_cancel_additems": "Cancel",
		"sprompt_license_additems": "By using @Table, you agree to our ",
		"sprompt_desc_tabitorder": "You will need to login to continue",
		"sprompt_ok_tabitorder": "Connect with <ilogow></ilogow>",
		"sprompt_cancel_tabitorder": "Cancel",
		"sprompt_license_tabitorder": "By using @Table, you agree to our ",
		"tabit_wallet": "<ilogod></ilogod> Wallet",
		"loyalty_required": "Please insert loyalty member to continue with the order",
		"code_with_letters": "I have a code with letters",
		"enter_code_with_letters": "Enter promo code",
		"cancel_benefits": "Cancel Benefits",
		"card_balance": "My balance",
		"benefits": "Rewards",
		"connect_info": "Enter phone no. or promo code",
		"expires": "Expires",
		"greeting": "Hi {{name}}!",
		"greeting_voucher": "Hi!",
		"loginSubCaption": "Sign in, enter promo code, or join our club",
		"loginSubCaptionVoucher": "Enter promo code",
		"member_not_found": "No member or voucher found",
		"of": "Of-",
		"points_balance": "My points",
		"punch_card_offer": "Remaining {{from}} of {{to}}",
		"review_points": "Use Points",
		"use_points": "Points",
		"signout": "Log Out",
		"skip": "Skip",
		"title": "Loyalty Member?",
		"title_voucher": "Do you have a voucher?",
		"title_club": "Club members have more fun",
		"voucher": "Voucher",
		"max_redeemable_points": "Max redeemable points",
		"my_benefits": "My Benefits",
		"my_balance": "Balance",
		"redeem_points_prompt_1": "Your points are worth money!",
		"redeem_points_prompt_2": "Maximum redeemable points in this order are {{points}}",
		"redeem_points_after": "You saved {{points}} by redeeming points",
		"select_club": "Pick a loyalty program\nand let the rewards roll",
		"not_interested_club": "Order as a guest",
		"not_interested_voucher": "Continue without Promo Code",
		"auth_title": "Confirmation code required",
		"auth_sub_title": "Confirmation code was sent to your phone",
		"auth_code": "Confirmation code",
		"auth_resend": "Resend confirmation code",
		"auth_verification_failed": "Phone verification failed",
		"error_voucher_redeemed": "This voucher has already been redeemed",
		"select_benefits": "Select the benefits you'd like\nto apply to your order",
		"select_additional_benefits": "Feel free to add the benefits below",
		"edit_benefits": "Edit benefits",
		"back_to_menu": "Back to menu",
		"select_benefits_max": "You can redeem up to {{val}} benefits in this order",
		"select_benefits_range": "You selected {{val}} of up to {{max}} benefits",
		"select_count_offers_for_benefit": "Please select <b class='_hl'>{{val}}</b> items",
		"select_one_offers_for_benefit": "Please select <b class='_hl'>one</b> item",
		"benefit_offers_selected_count": "<b class='_hl'>{{val}}</b> items selected",
		"benefit_offers_selected_count_one": "<b class='_hl'>One</b> item selected",
		"store_points": "Store points",
		"compensation": "Compensation",
		"select_item": "Select",
		"confirmCancel_benefit": "Remove benefit from this order?",
		"confirmDeleteOffer_reserved": "Removing the item will cancel the benefit!\nRemove the item?",
		"your_auto_benefits": "Additional benefits waiting for you",
		"pay_with": "Pay with",
		"btn_bar_edit": "My Account",
		"error_renew_forbidden": "Your Membership Has Expired.\nTo enjoy the Loyalty program rewards, you must renew your membership",
		"CustomerMustCompleteTheRegistration": "To add the club member to the order, please fill out the registration form sent by SMS or in our app.",
		"minimum_order_required_message": "After adding your rewards,\nyour order total comes to {{total}}{{currency}}\nand doesn't meet the minimum {{amount}}{{currency1}} required"
	},
	"_LOYALTY_REG": {
		"registration_error": "An error has occurred, cannot complete sign-up",
		"registration_update_error": "Error updating registration",
		"missing_offers_error": "Sign-up offer is missing",
		"missing_offers_reg_error": "Unable to complete the join process, please contact the restaurant",
		"first_name": "First name",
		"last_name": "Last name",
		"register": "Register",
		"regTitle": "Club membership gives you more!",
		"regDetailsTitle": "Hi, nice to meet you",
		"regDetailsDescription": "Register for our club\nto start enjoying benefits\nreserved for members only",
		"regSuccessTitle": "Members of the loyalty program enjoy more!",
		"regSuccesCaption": "For you to get access to all loyalty program benefits, you need to fill in all details in the link sent to you via SMS",
		"regPaySuccesCaption": "For you to get access to all loyalty program benefits, you need to fill in all details in the link sent to you via SMS",
		"sms_additional_info_sent_reg": "We sent you an SMS text with a link.\nFill in your information to enjoy even more benefits!",
		"sms_additional_info_sent_update": "We sent you an SMS text with a link.\nFill in your information to enjoy even more benefits!",
		"regPaySuccesComment": "*Joining the club fee is {{price}}, the charge will be added to your order automatically",
		"regCancelSMSPrompt": "Need more time?\n\nWe would like to send you an SMS text to complete your registration and enjoy all of our Club Member benefits",
		"loginPayExpiredTitle": "Long time no see, {{name}}!",
		"loginPayExpiredCaption": "For you to enjoy the club benefits, we'll need to renew your membership",
		"loginPayExpiredComment": "Renewing the membership fee is {{price}}, the charge will be added to your order automatically",
		"confirmDeleteOffer": "Removing this item will cancel the club sign-up. Are you sure?",
		"removeOfferButton": "Remove",
		"keepOfferButton": "Never mind",
		"membership_expired_at": "Membership expired on",
		"registration_contract": "I agree to the loyalty program terms and conditions",
		"read_contract": "Read the loyalty program terms and conditions",
		"registration_terms": "By creating an account, you are agreeing to receive promotional materials via SMS text.\nYou can remove yourself from this list at any point.",
		"birthDate": "Date of birth",
		"anniversary": "Anniversary",
		"email": "Email",
		"zehut": "Id Card",
		"another_time": "Another Time",
		"no_thanks": "No, Thank You",
		"send_sms": "Send SMS",
		"after_reg_add_details_title": "{{name}}\nwelcome to the club!",
		"after_reg_add_details_description": "Fill in a few more details to enjoy extra benefits",
		"after_reg_benefits_caption": "Here are some of the benefits waiting for you",
		"terms_required_title": "{{name}}",
		"terms_required_description": "your registration is almost complete! Just a few more things and you'll receive your benefits",
		"expired_soon_title": "Time flies!",
		"expired_soon": "Your membership is about to expire on {{date}}.\n\nRenew it now for {{price}} to continue enjoying a world of benefits",
		"expired_soon_accept": "Renew",
		"expired_soon_decline": "Not Now"
	},
	"NATIVE_PAYMENT": {
		"error_dialog_title": "We are unable to process your request at the moment.",
		"error_dialog_description": "Please select another payment method",
	},
	"MESSAGES": {
		"CONFIRM_SIGNOUT": "Are you sure you want to sign out?",
		"PAYMENT_CHALLENGE": "Verification code was sent to<i>{{phone}}</i>via SMS.",
		"PAYMENT_CHALLENGE_RETRY": "The code is wrong!\n Another verification code was sent via SMS",
		"INVALID_ORDER": "<h4>This page is no longer available</h4>This order may already be closed, or the link may no longer be valid.",
		"SAVE_INFO_PAYMENT": "Save payment information",
		"PAYMENT_ACCEPTED_SUCCESSFULLY_WITH_AMOUNT": "{{amount}} Successfully paid",
		"ITEM_ADDED_SUCCESSFULLY": "Order updated successfully",
		"ITEM_ADDED_PENDING": "Order request dispatched",
		"NO_PMS_FOUND": "No payment method found in your account.",
		"NO_SITE_PMS_FOUND": "Payment method is not set.",
		"PAYMENT_ACCEPTED_SUCCESSFULLY": "Payment accepted",
		"LIMIT_UPDATED_SUCCESSFULLY": "Limit updated successfully",
		"PAY_ORDER_CHANGED": "Order has changed. Please go over the order.",
		"CONTINUE_WITHOUT_GRATUITY": "Are you sure you want to continue without a tip?",
		"GRATUITY_NOT_ALLOWED_FOR_PM": "This restuarant doesn't accept tips with {{pm}}.\n Please select another payment method, or delete the tip.",
		"DO_YOU_APPROVE_CONTRACT": "Do you accept the terms of use?",
		"ENTER_ORDER_NO_INFO": "The server has a code for you",
		"saved_successfully": "Saved successfully",
		"Q_REMOVE_CARD": "Are you sure you want to delete this card?",
		"deleted_successfully": "Deleted successfully",
		"SIGNOUT_SUCCESS": "Logged out successfully",
		"GRATUITY_PA_WARNING": "This restaurant accepts tip with {{pms}} only",
		"SERVER_ERROR": "Sorry, service is temporarily unavailable,\n please try again later",
		"SESSION_VALIDATION_FAILED": "There was an error processing the request, please refresh the page and try again",
		"PROBLEM_IN_PAYMENT_INPUT": "An error occurred. \n Please enter payment details again \n If the problem occurs again, please contact the restaurant: \n {{phone}}",
		"CANNOT_PAY_TRAINING_MODE": "The system is in training mode, please contact the restaurant \n {{phone}}",
		"ORDER_RELOAD_NEEDED": "Please note, order balance has changed",
		"OUT_OF_STOCK": "Oops!\n During the order, the following items were sold out:\n {{items}}\n Please update the order accordingly.",
		"PAYMENT_LOCKED": "An error occurred, please try again",
		"ORDER_NEWPAYMENT_NEEDED": "Please note, the order balance has changed. Please enter a new amount",
		"ORDER_REQUIERES_IDCARD": "The payment amount is too high, please reduce the amount or contact the server",
		"PAYMENT_ERROR": "Please check payment details",
		"EX_PAYMENT_ERROR": "Payment error, please try again",
		"ORDER_HELD_BY_SERVER": "Sorry, you can't pay right now. Please try again later",
		"SHVA_OFFLINE": "Cannot pay with credit right now, pls try with a different payment method or try again later.",
		"PAYMENT_NOT_SUPPORTED": "We don't currently accept this card type. Please try again with another card",
		"CARD_VALIDATION_MISMATCH": "Card validation mismatch",
		"EX_PAYMENT_AUTHRIZATION_ERROR": "Error authorizing external payment",
		"PREAUTH_ERROR": "Your credit card has already been Pre-Authorized when you started the tab.\n\nPlease ask your server/bartender to cancel that Authorization if you wish to pay via your phone",
		"PAYMENT_QUOTA_EXCEEDED": "The card balance is insufficient ({{v}})",
		"PAYMENT_ABOVE_CREDIT_MAX": "You cannot pay more than 1500 NIS with the same card. To continue payment, please contact the team",
		"CREDIT_CARD_3DS_DISCLAIMER": "You may receive a verification code by SMS text or email. Please enter it if prompted.",
		"CREDIT_CARD_3DS_DISCLAIMER_more": "By clicking on the “Continue” button, I confirm the transaction details and acknowledge the cancellation policy as per the Payment Services Law.",
		"INVALID_PAYMENT_AMOUNT": "Invalid payment amount",
		"ITEM_OUT_OF_STOCK_MESSAGE": "Sold out! We're out of this item for now, check the menu for more great picks",
		"TABLE_X_NOT_FOUND": "Table {{v}} isn’t showing up. Check the number or ask the staff for help",
		"OUT_OF_BALANCE": "Oops! Your tab has reached its limit\n\nTo keep ordering, the tab limit must be increased by the owner.",
		"ONLINE_TABLE_ORDERING_DISABLED": "Online ordering at the table is disabled",
		"LOAD_RESOURCE_ERROR": "An error occurred",
	},
	"SERVER_MESSAGES": {
		"INVALID_ORDER_ID": "The order was not found",
		"EMAIL_NOT_FOUND": "Email was not found",
		"CREDIT_GUARD_EX_ERROR": "CreditGuard Payment Failed",
		"CREDIT_EX_ERROR": "Payment Failed",
	},
	'PMS': {
		"creditCard": "Credit",
		"creditGuard": "Credit",
		"Cibus": "Cibus",
		"10bis": "Ten Bis",
		"adyen": "Adyen",
		"tabit": "Credit (Tabit)"
	},
	"PO": {
		"TABLE_BILL": "Table",
		"WAITER": "Server",
		"ORDER_NO": "Order No",
		"ORDERER_NAME": "Orderer Name",
		"ORDERER_PHONE": "Phone",
		"ORDER_TO": "Order to",
		"OTH": "OTH",
		"ITEM_DISCOUNT": "Item discount",
		"TICKET_DISCOUNT": "Ticket discount",
		"ORDER_DISCOUNT": "Order discount",
		"TICKET_OTH": "On the house",
		"CHANGE": "Change",
		"WITHOUT": "Without",
		"ORDER_TOTAL": "Order total",
		"CHECK_TOTAL": "Check total",
		"ORDER_TIP": "Tip",
		"PAID": "Paid",
		"REMAINED_PAY": "Balance Due"
	},
	"VALIDATIONS": {
		"CREDIT_CARD": "Invalid card NO",
		"CREDIT_CARD_EXPIRATION": "Invalid expiration",
		"ID_CARD": "Invalid ID card",
		"NAME_FIELD": "Chars only!",
		"CELL_FIELD": "Invalid cell number",
		"CELL_FIELD_MSG": "Invalid cell number",
		"EMAIL_FIELD": "Invalid Email",
		"ZIPCODE": "Invalid Zip",
		"MAXLENGTH": "Cannot be longer than {{val}} characters."
	},
	"_CODES": {
		"409012": "Over Tender Not Allowed",
		"409023": "Payment Failed",
		"409028": "Order Payment Documents Not Issued",
		"409030": "Orderer already has an open order on this table",
		"409036": "Another Payment In Process",
		"409039": "Course Has Incomplete Item",
		"409040": "Item Inventory Out Of Stock",
		"409073": "Payment TimedOut",
		"409091": "Process Online Order Failed",
		"409092": "Pay For Online Order Failed",
		"409093": "Payment Provider Timeout",
		"409098": "Payment Service Unavailable",
		"409110": "Send Sms Message Failed",
		"409136": "Online Order Already HandedOff",
		"409806": "Credit Card Not Supported",
		"409808": "Credit Card Expired",
		"409809": "Credit Card Check Digit",
		"409810": "Credit Card CVV Error",
		"409181": "HandoffRequiresPayment error"
	},
	"WEIGHT":{
		"GRAM": "grams"
	},
	"_GIFTCARD": {
		"title": "Gift Card",
		"gift_card": "Gift Card",
		"gift_cards": "Gift Cards",
		"select_card": "Select a Card",
		"please_select_card": "Please select a card",
		"edit_card": "Edit gift card",
		"add_card": "Add gift card",
		"number": "Card number",
		"amount": "Amount to pay",
		"balance": "Card balance",
		"max": "Max amount",
		"cvv": "CVV",
		"cvv_required": "CVV required",
		"invalid_cvv": "Invalid CVV number",
		"inuse_error": "The same card cannot be used more than once in the same order",
		"balance_error": "Card has no balance",
		"notfound_error": "Card not found!",
		"delete_prompt": "Are you sure?",
		"no_order_amount": "Order is fully covered, no need to add another payment",
		"reset_split_payments_prompt": "Adding or updating a gift card will reset split payments. Continue?",
		"please_finish_payment": "Press 'Pay' to finish the order",
		"otp_required": "Confirmation code required",
		"otp_required_alt": "Confirmation code was sent to",
		"otp_required_alt_num": "*******{{v}}",
		"otp_alt": "Confirmation code",
		"invalid_otp": "Invalid Confirmation code",
		"resend_otp": "Resend confirmation code",
		"cannotPayOnOnline": "This type of Card is not available to be used online, but you may be able to use it at the restaurant",
	},
	"ACCESS": {
		"ACCESSIBILITY": "Accessibility Menu",
		"ACCESSIBILITY_IN_PROGRESS": "",
		"CLEAR_ACCESSIBILITY_FEATURES": "Clear accessibility features",
		"monochrom": "Monochrome",
		"light-contrast": "Light contrast",
		"dark-contrast": "Dark contrast",
		"enlarge-font": "Enlarge font",
		"reduce-font": "Reduce font",
		"readable-font": "Readable font",
		"weelchair": "Reduce height",
		"big-white-curser": "Big black cursor",
		"big-black-curser": "Big white cursor",
		"enlarge-frame": "Enlarge",
		"highlight-links": "Highlight links",
		"highlight-headers": "Highlight headings",
		"image-info": "Picture info",
		"declaration": "Accessibility declaration..."
	},
	"BADGES": {
		"new": "New",
		"sale": "Sale"
	},
	"OAT": {
		"tab_welocme": "Welcome to {{v}}",
		"tab_welocme_desc": "How would you like to order?",
		"table_number": "Table number",
		"table_no": "Table number {{v}}",
		"table_no_alt": "Table number <emlg>{{v}}</emlg>",
		"create_or_share_tab": "Open tab",
		"menu_prompt_title": "Start or join a tab",
		"menu_prompt_desc": "Join an existing tab or pre-auth your card and add items as you go.",
		"menu_prompt_bottom_title": "Opt to Tab it",
		"menu_prompt_bottom_desc": "Pre-auth your card and add items as you go. Invite others to order on your tab too!",
		"start_prompt": "Welcome to the fastest way to order and pay on your own",
		"order_from_the_menu": "Order from the menu",
		"create_tab_order": "Start a Tab",
		"create_tab_order_desc": "Pre-auth your card and order as you go OR invite your mates to join",
		"join_tab_order": "Join a Tab",
		"join_tab_order_desc": "Enter the group tab code to get started",
		"solo_order": "Order & Pay",
		"solo_order_desc": "Start your order and pay as you go",
		"manage-tab-order": "Manage tab",
		"create_tab_title": "Open Group Tab",
		"create_tab_details_info": "A simple way to order with friends and family",
		"field_tab_name": "Tab name",
		"default_tab_name": "{{name}}'s Tab",
		"field_full_name": "Full name",
		"field_phone": "Mobile",
		"charge_disclaimer": "To secure your order, we temporarily authorize {{v}} on your card. You’ll only be charged for the actual amount of your tab once it’s closed.",
		"join_tab_title": "Join an existing tab",
		"join_tab_details_info": "Enter the Group Tab's code to join. You can get this code from the owner of the Group Tab.",
		"field_order_no": "Enter order code",
		"manage_tab_title": "Manage tab",
		"manage_tab_details_info": "Manage tab details",
		"current_preauth": "Current tab limit",
		"remaining_preauth": "Remaining amount",
		"field_amount_limit": "Set tab limit",
		"increase_amount_limit": "Top up",
		"increase_amount_limit_desc": "Add to current tab limit",
		"add_new_tab_limit": "Add new tab limit",
		"share_my_tab": "Share your tab",
		"close_my_tab": "Pay and Close",
		"share_order_title": "Share your tab",
		"share_order_info": "You’re good to go!",
		"share_order_qr_info": "You can now get people to scan this QR code to use the tab.",
		"share_order_share_button": "Share your tab",
		"share_order_link_button": "Copy link",
		"share_order_button_title": "Share header from the button",
		"share_order_api_title": "Share header from sharing in browser",
		"desc_a": "Secure Payment",
		"desc_b": "Order as you go",
		"desc_c": "Pay",
		"share_tab_splash_title": "Optional: Share your tab",
		"share_tab_splash_info": "Friends can order under your tab, using the same pre-authorized payment method.",
		"review_before_sending_title": "Require approval before sending items to the kitchen",
		"review_before_sending_info": "Members’ items will be sent to the kitchen only after your approval.",
		"user_joined_tab": "Hi! {{name}} has joined the order",
		"close_tab_message": "<b>Close the tab and proceed to payment?</b><br/>No changes can be made after this step, and additional taxes or fees may apply to the final amount.",
		"action_in_progress_error": "We’re still processing your previous request. Please try again in a moment",
		"ordered-by": "Ordered by",
		"default_charge_tip": "A {{val}}% service fee is also pre‑authorized. If you leave without closing your tab by yourself, this fee may be applied and charged.",
		"fixed_charge_amount_title": "you’ll only be charged for the actual total.",
		"fixed_charge_amount": "To secure your order, we place a temporary {{val}} hold on your card. When you close your tab, you’ll only be charged for the actual total.",
		"share_anonymous_prompt": "<div class='text-center'></div><b>Open Tab isn’t available in guest mode.</b><br/<br/>you can easily order directly from the menu.</div>",
		"order_anonymous_from_the_menu": "Order from the menu",
		"select_how_to_pay": "Select how to pay",
		"pay_with_saved_card": "Pay with saved card",
		"pay_in_full": "Pay in full",
		"partial_payment": "Split payment",
		"order_start_title": "Order Started! 🍻",
		"order_start_content": "Keep this page open for your next orders. You can always return to it using the link we sent via SMS",
		"offers_pending_approval": "Pending approval",
		"offers_approve-all": "Approve all",
		"offers_approve-decline": "Manage requests",
		"confirm_approve_all_requests": "Approve all requests?",
		"approve_selected_requests": "Approve selected",
		"confirm_approve_selected_requests": "Approve selected requests?",
		"decline_selected_requests": "Decline selected",
		"confirm_decline_selected_requests": "Decline selected requests?",
		"approve_all_requests": "Approve all requests",
		"decline_all_requests": "Decline all requests",
		"last4": "4 ספרות אחרונות",
		"validate_last4_title": "Validate your card",
		"validate_last4_desc": "Enter the last 4 digits of your card to validate it",
	},
	'_TABLEO': {
		'start_prompt': 'Explanation of table reservation',
		'new_table_order': 'New table order',
		'join_table_order': 'Join table order',
		'err_creating_table_order': 'An error occurred while creating a table reservation',
		'order_forphone_exist': 'There is already an open order on you!\nRedirecting to order...'
	},
	'TD': {
		'menu_title': "Add items to order",
		'to-update': "Update",
		'to-add': "Add",
		'clear_selection': 'Clear',
		'cancel': 'Cancel',
		'my-order': 'My order',
		'items-summary': 'Item summary',
		'add-items': 'Add items',
		'add-items-alt': "Send to kitchen",
		"no_basket_items": "No items in basket",
		"find_offers": 'Find...',
		"msg_timeout": "Your order has timed out, but don’t worry, you can start over in no time!",
		"msg_expired": "Apologies, the time limit for your order has expired",
		"restart_order": "Restart order",
		"continue": "Continue",
		"payup": "Pay",
		"not_interested": "No, thanks",
		"not_interested_alt": "No thanks. Continue",
		"additional_offers": "Additional Items",
		"select_additional_offers": "Select additional items",
		"prep_time": "Preparation time: about <b>{{v}}</b> minutes",
		"historic_orders": "Previously ordered",
		"loading": "Hang tight! We’re on it",
		"alcohol_decleration": "I am {{age}}+ years of age and will provide identification to verify alcohol purchase",
		"service_unavailable": "<h4>Sorry</h4>The service is currently unavailable",
		"missing_configuration": "<h4>Sorry</h4>The service is currently unavailable",
		"takeaway_not_supported": "<h4>Sorry</h4>The service is currently unavailable",
		"service_outside_workhours": "<h4>Sorry</h4>The service is currently unavailable",
		"offers_not_matched": "<b>Not all items from your previous order are currently available.</b><br><br>{{offers}}<b><br><br>Do you wish to continue?</b>",
		"offer_not_available": "{{name}} is not available",
		"this_offer_exists": "This item is already in your cart.\nWhat would you like to do?",
		"select_offer_to_edit": "Select an item to edit",
		"or_add_new": "or",
		"add_new_offer": "Add new",
		"edit_existing": "Edit existing",
		"add_another_same": "Add another"
	},
	'TO': {
		'menu_title': 'Order & Pay',
		'extraoffers_title': 'Extra Offers',
		'tip_title': 'Tip',
		'pay_title': 'Pay',
		'continue-from-summary': 'Continue',
		'back-to-menu': 'Add more items',
		'tax': 'Tax',
		'fees': 'Fees',
		'tip': 'Tip',
		'total-to-pay': 'Total Payment',
		'total-items': 'Total Items',
		'restart-order': 'Restart order',
		'add_another_order': 'Order again',
		'reorder': 'Order again',
		"q_confirm_reset_order": "Starting fresh? This will empty your cart and take you back to the menu",
		"q_remove_offer_from_basket": "Are you sure you want to remove this item from the basket?",
		"end_success_title": "Sent! \nThe kitchen’s got it from here",
		"change_to_takeaway": "Change order to pickup",
		"q_change_to_takeaway": "Change to pickup?",
		"dine_in": "Dine in",
		"change_to_takeaway_unavailable": "Sorry\nThe service is currently unavailable.",
		"takeaway_title": "Pickup order",
		"add_items_prompt": "Once you order,\n your items will appear here",
		"offer_added_toast": "Added: {{val}}",
		"offer_added_to_benefit": "This reward has been applied to the item in you cart",
		"table_number_title": "Enter Table",
		"enter_table_number": "Table number",
		"takeaway_instead": "Pickup order instead"
	},
	'_APP': {
		"open-cam-prompt": "Ready to order?",
		"open-cam-desc": "Get started by scanning the QR code on your table, simply open your device's camera to begin.",
		"scan-qr-desc": "Get started by scanning the QR code on your table, simply click this to begin.",
		"open-cam-desc-signed": "Already in the restaurant?\nOpen your device's camera to scan the QR code.",
		"scan-qr-signed": "Already in the restaurant?\nClick to scan the QR code",
		"login-prompt": "Already ordered with us?\nLog in here",
		"no-orders-title": "Looks like you haven't ordered yet.",
		"no-orders-desc": "Once you do, your recent orders and favorite restaurants will appear here.",
		"recent-sites": "Recently visited restaurants",
		"recent-orders": "Recent Orders",
		"invalid-qr-scan": "Sorry\nThe scanned QR code is invalid.",
	},
	"without": "Without",
	"GROUP_VALIDATION": {
		"select_one": "Select one",
		"between_amount": "Between {{min}} and {{max}}",
		"GROUP_MOD_SELECT_SINGLE_ERROR": "Select at least one topping from: {{group}}",
		"GROUP_SELECT_ERROR": "Select at least {{count}} items from: {{group}}",
		"GROUP_SELECT_SINGLE_ERROR": "Select at least one item from: {{group}}",
		"SELECT_ATLEAST_ONE": "Please select at least one",
		"SELECT_ATLEAST_SOME": "Please select at least {{min}}",
		"SELECT_BETWEEN": "Please select between {{min}} and {{max}}",
		"SELECT_ONE": "Please select one",
		"SELECT_SOME": "Please select {{min}}",
		"SELECT_UPTO_ONE": "Please select up to one",
		"SELECT_UPTO_SOME": "Please select up to {{max}}",
		"SELECT_UPTO_SOME_ALT": "Select up to {{max}}",
		"MAX_ITEMS_COUNT": "Can't order more than {{max}} items",
		"MAX_ITEMS_AMOUNT": "Can't order above {{max}}",
		"MOD_CANT_SELECT_MORE_THEN": "Please select no more than {{max}} sides",
		"OUT_OF_STOCK": "The following items are no longer in stock:\n {{items}} . \n Please make a new selection",
	},
	"tabot": {
		"confirm_reset_title": "Reset Chat",
		"confirm_reset_message": "Are you sure you want to reset the chat? This action will delete all messages and the basket.",
		"confirm_reset_yes": "Yes, Reset",
		"confirm_reset_no": "Cancel",
		"general_error": "A general error occurred. Please try again.",
		"offer_not_found": "No suitable offer found.",
		"processing": "Processing request...",
		"processing_retry": "Processing request... (attempt {{attempt}} of {{maxAttempts}})",
		"error_with_code": "Error: {{message}} (code: {{statusCode}})",
		"network_error": "Network error. Please check your internet connection.",
		"timeout_error": "Request timeout. Please try again.",
		"max_retries_exceeded": "Maximum number of attempts reached. Please try again later.",
		"unexpected_error": "An unexpected error occurred. Please try again.",
		"successful_message": "Order placed successfully!",
		"basket_error": "Error updating basket.",
		"invalid_response": "Invalid response from server.",
		"no_offers": "No offers found.",
		"chat_error": "Chat error.",
		"error": "Error",
		"empty_basket": "Basket is empty.",
		"feedback_needed": "User feedback required.",
		"single_item_added": "{{item}} added to basket.",
		"multiple_items_added": "Added to basket: {{items}}.",
		"single_item_needs_edit": "{{item}} requires editing.",
		"multiple_items_need_edit": "The following items require editing: {{items}}.",
		"multiple_items_need_edit_error": "There are items that require editing.",
		"creating_order": "Creating your order items...",
		"checking_order": "Checking order...",
		"header_title": "Tabot - Your Personal Restaurant Ordering Assistant",
		"mobile_header_title": "TABOT",
		"input_placeholder": "Type a message...",
		"voice_message_sent": "Voice message sent.",
		"voice_message_transcribed": "Voice message translated ${text}",
		"voice_message_error": 'Voice message error',
		"sync_basket": "Synchronize basket",
		"out_of_stock": "Out of stock",
		"text_size": "Text size",
		"edit_offer": "Edit offer",
		"delete_offer": "Delete offer",
		"offers_need_input": "The following items require additional input",
		"find_me": "Find me...",
		"offer_not_found_in_catalog": "Offer not found in catalog",
		'reset_search': "Click to reset search...",
		'checking_upsell_message': 'Just a minute, we are checking your basket...',
		'upsell_prompt': 'Custom add-ons, just for you',
	},
	_QK: {
		"advanced_search": "Advanced search",
		"chat_language": "Chat language",
		"free_search": "Ask me anything...",
		"apply_search": "Apply search",
		"add-items": "Add items",

		'FindByPropsPattern': 'find items from {{category}} that are: {{characteristics}}',
		'MealRecommendationPattern': 'A meal recommendation for {{noAdults}} adults and {{noChildren}} children on a budget of {{budget}} NIS, excluding drinks',
		'FindByPricePattern': 'find items on the menu priced between ₪5 and {{budget}}₪',
	},
	"NO_TRANS_DANA" : "Dana didn't provide a translation",
};
